/** Lig slug → /public/sport/leagues dosya adı */
const LEAGUE_LOGO_FILE: Record<string, string> = {
  all: 'default-logo.webp',
  'super-lig': 'super-lig.png',
  'tff-1-lig': 'tff-1lig.png',
  'tff-2-lig': 'default-logo.webp',
  'turkiye-kupasi': 'turkiye-kupasi.png',
  'premier-lig': 'premier-lig.png',
  'ingiltere-premier-ligi': 'premier-lig.png',
  championship: 'premier-lig.png',
  bundesliga: 'bundesliga.png',
  'almanya-bundesliga': 'bundesliga.png',
  'serie-a': 'serie-a.png',
  'italya-serie-a': 'serie-a.png',
  'fransa-ligi': 'fransa-ligi.png',
  'fransa-ligue-1': 'fransa-ligi.png',
  'la-liga': 'la-liga.png',
  'ispanya-la-liga': 'la-liga.png',
  'hollanda-ligi': 'default-logo.webp',
  'sampiyonlar-ligi': 'sampiyonlar-ligi.png',
  'avrupa-ligi': 'avrupa-ligi.png',
  'uefa-avrupa-ligi': 'avrupa-ligi.png',
  'konferans-ligi': 'konferans-ligi.png',
  'dunya-kupasi': 'default-logo.webp',
  'dunya-kupasi-elemeleri': 'default-logo.webp',
  'avrupa-sampiyonasi': 'avrupa-sampiyonasi.png',
  'avrupa-sampiyonasi-elemeleri': 'avrupa-sampiyonasi.png',
  'milletler-ligi': 'milletler-ligi.png',
  'super-kupa': 'super-lig.png',
  'milli-takim-hazirlik': 'default-logo.webp',
  hazirlik: 'default-logo.webp',
}

export function leagueLogoSrc(slug: string): string {
  const file = LEAGUE_LOGO_FILE[slug] || 'default-logo.webp'
  return `/sport/leagues/${file}`
}

export function standingsPath(slug?: string | null): string {
  if (!slug || slug === 'super-lig') return '/spor/puan-durumu'
  return `/spor/puan-durumu/${encodeURIComponent(slug)}`
}

export function matchesPath(slug?: string | null, day?: string | null): string {
  const base = !slug
    ? '/spor/canli-maclar'
    : `/spor/canli-maclar/${encodeURIComponent(slug)}`
  if (day) return `${base}?tarih=${encodeURIComponent(day)}`
  return base
}

export function fixturesPath(
  slug?: string | null,
  hafta?: number | null | 'all',
): string {
  const base = !slug
    ? '/spor/fikstur'
    : `/spor/fikstur/${encodeURIComponent(slug)}`
  if (hafta === 'all') return `${base}?hafta=all`
  if (hafta != null && Number.isFinite(hafta) && hafta > 0) {
    return `${base}?hafta=${hafta}`
  }
  return base
}

/** Takım logosu — Broadage CDN (production /api yolu backend'e yönlendiği için doğrudan CDN). */
export function teamLogoSrc(
  sport: string | null | undefined,
  teamId: number | null | undefined,
): string | null {
  if (!teamId || !Number.isFinite(teamId)) return null
  const kind =
    sport === 'basketball' || sport === 'volleyball' ? sport : 'soccer'
  return `https://cdn.broadage.com/images-teams/${kind}/72x72/${Math.trunc(teamId)}.png`
}
